module.exports = __webpack_public_path__ + "img/devices.d0e77bd.svg";